<div>
  @if (friends()?.length) {
  <div class="fr-label ac-label ac-label-md">
    My Friends
  </div>
  <div class="ac-flex-col ac-gap-lg">
    @for (friend of friends(); track friend.user_id) {
    <div class="fr-user-row ac-flex ac-algn-ctr ac-sp-btw">
      <app-user-avatar [user]="friend" />
      <button
        mat-icon-button
        [matMenuTriggerFor]="menu"
        class="fr-menu-icon"
        [class.fr-menu-open]="!!friendMenuOpenByUserId()[friend.user_id]"
        (menuOpened)="friendMenuOpenByUserId()[friend.user_id] = true"
        (menuClosed)="friendMenuOpenByUserId()[friend.user_id] = false"
        type="button"
      >
        <ac-icon iconKey="hr:ellipsis_horizontal" [size]="24" />
      </button>
      <mat-menu #menu="matMenu">
        <button mat-menu-item (click)="removeFriend(friend)">
          Remove Friend
        </button>
      </mat-menu>
    </div>
    }
  </div>
  }
</div>
